import React from 'react';
import { getSiteName } from '../utils/theme';

const Features: React.FC = () => {
  const features = [
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
        </svg>
      ),
      title: "Мгновенная генерация",
      description: "Получайте качественный контент за секунды. Наша нейросеть работает в режиме реального времени, предоставляя результаты мгновенно."
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
        </svg>
      ),
      title: "Интеллектуальный анализ",
      description: "ИИ понимает контекст, стиль и требования. Каждый текст создается с учетом ваших потребностей и целевой аудитории."
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100 4m0-4v2m0-6V4" />
        </svg>
      ),
      title: "Гибкие настройки",
      description: "Настраивайте тон, стиль и длину текста. Gekata адаптируется под любые задачи - от коротких постов до развернутых статей."
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      ),
      title: "Безопасность данных",
      description: "Ваша информация защищена современными методами шифрования. Мы не сохраняем и не передаем ваши данные третьим лицам."
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
        </svg>
      ),
      title: "Высокое качество",
      description: "Используем передовые языковые модели для создания естественного и качественного контента, неотличимого от человеческого."
    },
    {
      icon: (
        <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1" />
        </svg>
      ),
      title: "Доступные цены",
      description: "Справедливое ценообразование для всех. Начните с пробного тарифа всего за 10 рублей или выберите выгодный базовый план."
    }
  ];

  return (
    <section id="features" className="py-10 px-4">
      <div className="container mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-elegant font-bold text-white mb-6">
            Почему выбирают 
            <span className="bg-gradient-to-r from-mystic-400 to-moonlight-400 bg-clip-text text-transparent font-elegant"> {getSiteName()}</span>?
          </h2>
          <p className="text-xl text-lunar-300 max-w-3xl mx-auto font-elegant">
            Откройте для себя силу древней мудрости, воплощенную в современных технологиях искусственного интеллекта
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div 
              key={index}
              className="bg-lunar-800/50 backdrop-blur-sm rounded-xl p-8 border border-[var(--primary-color-800-30)] hover:border-[var(--primary-color-600-50)] transition-all duration-300 hover:transform hover:scale-105"
            >
              <div className="w-16 h-16 bg-mystic-gradient rounded-full flex items-center justify-center mb-6 text-white">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-white mb-4">{feature.title}</h3>
              <p className="text-lunar-400 leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>

        {/* Mystical Decoration */}
        <div className="mt-16 text-center">
          <div className="inline-flex items-center space-x-4 text-mystic-400">
            <div className="w-12 h-0.5 bg-gradient-to-r from-transparent to-mystic-400"></div>
            <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 24 24">
              <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
            </svg>
            <div className="w-12 h-0.5 bg-gradient-to-l from-transparent to-mystic-400"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Features;